import React from 'react';
import Intercom from 'react-intercom';
import getEnvVariable from '../../utils/env';

// exemple User
// name: "Jane Doe", // Full name
// email: "customer@example.com", // Email address
// created_at: "1312182000" // Signup date as a Unix timestamp
const WrapperIntercom = ({ user }) => {
  const nodeEnv = getEnvVariable('NODE_ENV');
  const reactAppIntercomToken = getEnvVariable('REACT_APP_INTERCOM_TOKEN');

  if (nodeEnv === 'development') {
    // eslint-disable-next-line no-console
    console.log('Intercom not initialized in development mode');
    return null;
  } else if (
    reactAppIntercomToken === undefined ||
    reactAppIntercomToken === ''
  ) {
    // eslint-disable-next-line no-console
    console.log(
      'Intercom not initialized, REACT_APP_INTERCOM_TOKEN is undefined'
    );
    return null;
  } else {
    return (
      <Intercom
        appID={reactAppIntercomToken}
        {...user}
        name={user ? `${user.firstname} ${user.lastname}` : undefined}
      />
    );
  }
};

export default WrapperIntercom;
